import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './Case.css';
import PageTitle from '../Layout/components/PageTitle';
import CaseInfo from '../Case/components/CaseInfo';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, InputBase, Dialog, Drawer, TableFooter, TablePagination } from '@material-ui/core';
import Search from '@material-ui/icons/Search'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SideList from '../Case/components/SideList'
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import { roleStr, defaultPageSize, ADD, EDIT, VIEW } from '../../common/common';
import { toMoney } from '../../common/utils';
import AlertDialog from '../Layout/components/AlertDialog'
import Toast from '../Layout/components/Toast';

class Case extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            stateRight: false,
            dialogTitle: "",
            dialogState: ADD,
            dialogData: null,
            totalUser: [],
            tabIndex: 0,
            client_id: 0,
            cases: [],
            showAlert: false,
            number: "",
            client_name: "",
            origin_attorney_id: "",

            showToast: false,
            toastMsg: "",
            toastState: "",

            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,
        }
        this.handleCreateCase = this.handleCreateCase.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleMatter = this.handleMatter.bind(this);
        this.handleBalance = this.handleBalance.bind(this);
        this.handleInvoice = this.handleInvoice.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleDrawer = this.handleDrawer.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            cases,
            showAlert,
            page_index,
            page_size,
            total_items,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        // const delBtn = (row) => {
        //     if (roleName === ADMIN) {
        //         return <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
        //     }
        // }
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="All Cases" subtitle="MANAGEMENT"></PageTitle>
                    <div className="f h h-r">
                        <Button className="btn" variant="contained" color="primary" onClick={this.handleCreateCase}>CREATE CASE</Button>
                    </div>
                </div>
                <div className="tableTool h">
                    {/* <Button className="bgW btn" variant="contained" onClick={e => this.handleDrawer(e, true)}> Show Filters </Button> */}
                    <div className="searchWapper h m-20">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search case by case number"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'caseNumber')}
                        />
                    </div>
                    <div className="searchWapper h">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search client name"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            onChange={e => this.handleSearch(e, 'client_name')}
                        />
                    </div>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Case Number</TableCell>
                                <TableCell>Client</TableCell>
                                {/* <TableCell>Email</TableCell> */}
                                <TableCell>Originating Attorney</TableCell>
                                <TableCell>Team</TableCell>
                                <TableCell>Department</TableCell>
                                <TableCell>Office</TableCell>
                                {/* <TableCell>Modified Time</TableCell>
                                <TableCell>Create Time</TableCell> */}
                                <TableCell>Balance</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {cases.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell component="th" scope="row">
                                        {row.number}
                                    </TableCell>
                                    <TableCell>{this.showIOrCName(row.client, "name")}</TableCell>
                                    {/* <TableCell>{this.showIOrCName(row.client, "email")}</TableCell> */}
                                    <TableCell>{this.attorneyInfo(row.handler, "name")}</TableCell>
                                    <TableCell>{this.attorneyInfo(row.handler, "team")}</TableCell>
                                    <TableCell>{this.attorneyInfo(row.handler, "dept")}</TableCell>
                                    <TableCell>{this.attorneyInfo(row.handler, "office")}</TableCell>
                                    <TableCell>${toMoney(row.balance)}</TableCell>
                                    {/* <TableCell>{timeFormat(row.update_time)}</TableCell>
                                    <TableCell>{timeFormat(row.create_time)}</TableCell> */}
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleMatter(e, row)}>Matter</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleBalance(e, row)}>balance</Button>
                                            {/* <Button variant="outlined" color="primary" onClick={e => this.handleInvoice(e, row)}>invoice</Button> */}
                                            {/* {delBtn(row)} */}
                                            <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {cases.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={cases.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Dialog maxWidth={false} open={this.state.open}>
                    <CaseInfo
                        handleCloseDialog={this.handleCloseDialog}
                        title={this.state.dialogTitle}
                        data={this.state.dialogData}
                        state={this.state.dialogState}
                    ></CaseInfo>
                </Dialog>
                <Drawer anchor="right" open={this.state.stateRight} onClose={e => this.handleDrawer(e, false)}>
                    <div
                        role="presentation"
                    >
                        <SideList
                            handleApply={this.handleApply}
                        ></SideList>
                    </div>
                </Drawer>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this case?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }
    componentDidMount() {
        const page_index = parseInt(localStorage.getItem('case_page_index'));
        const page_size = parseInt(localStorage.getItem('case_page_size'));
        if (page_index && page_size) {
            this.setState({
                page_index,
                page_size
            }, () => {
                this.getCases();
            })
        } else {
            this.getCases();
        }
    }
    getCases() {
        const { page_index, page_size, number, client_name } = this.state;
        let params = {
            number: number ? number : null,
            client_name: client_name ? client_name : null,
            // origin_attorney_id,
            page_index,
            page_size
        }
        this.getCase(params);
    }
    handleCreateCase() {
        this.setState(() => ({
            dialogData: null
        }))
        this.openDialog("CREATE CASE", ADD);
    }
    handleView(e, obj) {
        this.setState(() => ({
            dialogData: obj
        }))
        this.openDialog("VIEW CASE", VIEW);
    }
    handleEdit(e, obj) {
        const client_id = obj.id;
        this.setState(() => ({
            dialogData: obj,
            client_id
        }))
        this.openDialog("EDIT CASE", EDIT);
    }
    handleDel(e, obj) {
        this.crtCaseId = obj.id;
        this.setState(() => ({
            showAlert: true
        }));
    }
    handleAlertYes() {
        this.delCase(this.crtCaseId);
        this.setState(() => ({
            showAlert: false
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false
        }));
    }
    handleMatter(e, obj) {
        const { page_index, page_size } = this.state;
        this.props.history.push({ pathname: '/main/matter' });
        localStorage.setItem('case_id', obj.id);
        localStorage.setItem('case_num', obj.number);
        localStorage.setItem('case_page_index', page_index);
        localStorage.setItem('case_page_size', page_size);
    }
    handleBalance(e, obj) {
        const { page_index, page_size } = this.state;
        this.props.history.push({ pathname: '/main/casebalance' });
        localStorage.setItem('case_id', obj.id);
        localStorage.setItem('case_num', obj.number);
        localStorage.setItem('case_page_index', page_index);
        localStorage.setItem('case_page_size', page_size);
    }
    handleInvoice(e, obj) {
        const { page_index, page_size } = this.state;
        this.props.history.push({ pathname: '/main/caseinvoice' });
        localStorage.setItem('case_id', obj.id);
        localStorage.setItem('case_num', obj.number);
        localStorage.setItem('case_page_index', page_index);
        localStorage.setItem('case_page_size', page_size);
    }
    handleCloseDialog() {
        this.getCases();
        this.closeDialog();
    }
    handleSearch(e, name) {
        const value = e.target.value;
        if (name === "caseNumber") {
            this.setState({
                number: value,
                page_index: 1
            }, () => {
                this.getCases();
            })
        } else if (name === "client_name") {
            this.setState({
                client_name: value,
                page_index: 1
            }, () => {
                this.getCases();
            })
        }
    }
    handleApply(obj) {
        console.log(obj)
        this.setState({
            page_index: 1,
            drawerOpen: false,
        }, () => {
            this.getCases();
        })
    }
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getCases();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getCases();
        });
    }
    handleDrawer(e, open) {
        this.setState(() => ({
            stateRight: open
        }));
    };
    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state,
        }));
    }
    showIOrCName(obj, name) {
        if (obj) {
            if (name === "name") {
                if (obj.individual) {
                    return obj.individual.first_name + " " + obj.individual.last_name;
                } else if (obj.corporation) {
                    return obj.corporation.name;
                }
            } else if (name === "email") {
                if (obj.individual) {
                    return obj.individual.email;
                } else if (obj.corporation) {
                    return "";
                }
            }
        }
    }
    getUserDepartment(teamData) {
        if (teamData) {
            if (teamData !== null && teamData.length > 0) {
                let deptObj = teamData[0].dept;
                let deptName = deptObj.name;
                return deptName
            }
        }
        return "";
    }
    attorneyInfo(handlerArr, type) {
        if (handlerArr) {
            let attorneyObj = {};
            for (const obj of handlerArr) {
                if (obj.is_origin_attorney) {
                    attorneyObj = obj;
                }
            }
            if (attorneyObj) {
                
                if (type === "name" && attorneyObj.user !== null) {
                    const userObj = attorneyObj.user;
                    return userObj.first_name + " " + userObj.last_name;
                } else if (type === "team" && attorneyObj.team !== null) {
                    const teamObj = attorneyObj.team;
                    return teamObj.name;
                } else if (type === "dept" && attorneyObj.team !== null) {
                    const teamObj = attorneyObj.team;
                    return teamObj.dept_info.name;
                } else if (type === "office" && attorneyObj.team !== null) {
                    const teamObj = attorneyObj.team;
                    return teamObj.dept_info.office;
                }
            }
        }
        return "--";
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    //---------------request---------------
    getCase(params) {
        instance.get(BASE_URL + roleStr() + '/cases', { params }).then((res) => {
            const cases = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(cases)
            this.setState(() => ({
                cases,
                page_size,
                total_items
            }));
        })
    }
    delCase(case_id) {
        const role = roleStr() === "admin" ? "admin" : "common";
        instance.delete(BASE_URL + role + '/cases/' + case_id).then((res) => {
            console.log(res)
            this.crtCaseId = "";
            this.getCases();
        }).catch((err) => {
            const errorCode = err.response.data.error;
            if (errorCode === 3000) {
                this.showToast("Failed to delete, the case has been used", "error");
            }
        })
    }
}

export default withRouter(Case);